import { Link } from "react-router-dom";
import { Instagram, ShoppingBag, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";
import { SHOP } from "@/data/site";

const NAV = [
    { to: "/", label: "Beranda" },
    { to: "/menu", label: "Menu" },
    { to: "/galeri", label: "Galeri" },
    { to: "/kontak", label: "Kontak" },
    { to: "/promo", label: "Promo" },
    { to: "/testimoni", label: "Testimoni" },
    { to: "/artikel", label: "Artikel" },
    { to: "/faq", label: "FAQ" },
    { to: "/tentang", label: "Tentang Kami" },
];

export default function Footer() {
    return (
        <footer data-testid="footer" className="bg-ink text-bg">
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
                <div className="flex flex-col justify-between gap-10 border-b border-white/10 pb-12 lg:flex-row lg:items-end">
                    <div>
                        <Logo light />
                        <p className="mt-5 max-w-sm text-sm leading-relaxed text-bg/60">
                            Cafe kecil di Bandar Lampung. Kopi yang
                            jujur, harga yang ramah — diseduh fresh setiap
                            hari.
                        </p>
                    </div>
                    <p className="font-display text-4xl font-extrabold tracking-tight text-bg/95 sm:text-5xl">
                        Good coffee, good mood<span className="text-accent">.</span>
                    </p>
                </div>

                <div className="mt-12 grid gap-10 sm:grid-cols-3">
                    <div>
                        <p className="text-xs font-bold uppercase tracking-[0.2em] text-bg/40">
                            Navigasi
                        </p>
                        <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
                            {NAV.map((l) => (
                                <Link
                                    key={l.to}
                                    to={l.to}
                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="text-sm font-semibold text-bg/75 transition-colors hover:text-accent"
                                >
                                    {l.label}
                                </Link>
                            ))}
                        </div>
                    </div>

                    <div>
                        <p className="text-xs font-bold uppercase tracking-[0.2em] text-bg/40">
                            Kunjungi
                        </p>
                        <div className="mt-5 flex flex-col gap-3 text-sm text-bg/75">
                            <span className="flex items-start gap-2.5">
                                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
                                {SHOP.address}
                            </span>
                            <span className="flex items-center gap-2.5">
                                <Clock className="h-4 w-4 shrink-0 text-accent" />
                                {SHOP.hours}
                            </span>
                        </div>
                    </div>

                    <div>
                        <p className="text-xs font-bold uppercase tracking-[0.2em] text-bg/40">
                            Terhubung
                        </p>
                        <div className="mt-5 flex flex-col gap-3">
                            <a
                                href={SHOP.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-link-instagram"
                                className="flex items-center gap-2.5 text-sm font-semibold text-bg/75 transition-colors hover:text-accent"
                            >
                                <Instagram className="h-4 w-4" />
                                {SHOP.instagramHandle}
                            </a>
                            <a
                                href={SHOP.gofood}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-link-gofood"
                                className="flex items-center gap-2.5 text-sm font-semibold text-bg/75 transition-colors hover:text-accent"
                            >
                                <ShoppingBag className="h-4 w-4" />
                                Pesan di GoFood
                            </a>
                        </div>
                    </div>
                </div>

                <p className="mt-14 border-t border-white/10 pt-8 text-xs text-bg/40">
                    © {new Date().getFullYear()} Yuhuku Kopi — Dikembangkan
                    sebagai bagian dari pengembangan presence digital UMKM.
                </p>
            </div>
        </footer>
    );
}